import React from 'react'
import Header from './components/header/Header'
import Nav from './components/nav/Nav'
import About from './components/about/About'
import Define from './components/define/Define'
import Rarity from './components/rarity/Rarity'
import History from './components/history/History'
import Collective from './components/collective/Collective'
import Questions from './components/questions/Questions'
import Twitterfeed from './components/twitterfeed/Twitterfeed'
import Footer from './components/footer/Footer'

const App = () => {
  return (
      <>
            <Header />
            <Nav />
            <About />
            <Define />
            <Rarity />
            <History />
            <Collective />
            <Questions />
            <Twitterfeed />
            <Footer />

      </>
  )
}

export default App